import { Body } from '@assembly-js/design-system';
import { t } from 'i18next';
import React from 'react';

import { StudioBillingInterval } from './studioPlanFeatures';

interface BillingIntervalToggleProps {
  interval: StudioBillingInterval;
  onChangeInterval: (interval: StudioBillingInterval) => void;
}

export const BillingIntervalToggle: React.FC<BillingIntervalToggleProps> = ({
  interval,
  onChangeInterval,
}) => {
  const options: Array<{ value: StudioBillingInterval; label: string }> = [
    {
      value: 'month',
      label: t(($) => $.page_studio_plans.choose_plan.monthly),
    },
    {
      value: 'year',
      label: t(($) => $.page_studio_plans.choose_plan.yearly),
    },
  ];

  return (
    <div className="flex w-fit items-center gap-2 rounded border border-solid border-non-hover-border p-1">
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className={`cursor-pointer rounded-sm border-0 px-1.5 py-0.5 ${
            interval === option.value ? 'bg-gray-150' : 'bg-transparent'
          }`}
          onClick={() => onChangeInterval(option.value)}
        >
          <Body size="xs" tag="span" className="text-black-heading">
            {option.label}
          </Body>
        </button>
      ))}
    </div>
  );
};
